import Modal from "@src/common/Modal";
import GuideImg from "@src/styles/webroot/images/guide-img.svg"

interface GuidePopupPopupProps {
    show: boolean;
    handleClose: () => void;
}

const GuidePopupPopup = ({
    show,
    handleClose,
}: GuidePopupPopupProps) => {
  
    return (
        <div className="model-outer guide-popup">
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-header">
                    <h2>Selfie with KTP Preview</h2>
                    <span>
                        Hold your KTP ID (front view) alongside your face, ensuring both your face and the ID are clearly visible within the frame
                    </span>
                </div>
                <div className="modal-body">
                    <img src={GuideImg} />
                </div>

                    <div className="modal-footer p-sm-t">
                    <button type="button" className="btn-line w-100" onClick={handleClose}>
                        Close
                    </button>
                    </div>
                
            </Modal>
        </div>
    );
};

export default GuidePopupPopup;
